import { render, staticRenderFns } from "./AddTableViewModal.vue?vue&type=template&id=0b39c360&"
import script from "./AddTableViewModal.vue?vue&type=script&lang=js&"
export * from "./AddTableViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports